import React from "react"
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import { Product } from "pages/vendor/Products/Products"
import { useTranslation } from "react-i18next"

interface ProductActionMenuProps {
  product: Product
  viewDetailsHandler: (product: Product) => void
  editProductHandler: (product: Product) => void
  deleteProductHandler: (product: Product) => void
  addNewOffer: (product: Product) => void
  addNewCampaign: (product: Product) => void
  duplicateProductHandler: (product: Product) => void
}

export const ProductActionMenu: React.FC<ProductActionMenuProps> = ({
  product,
  viewDetailsHandler,
  editProductHandler,
  deleteProductHandler,
  addNewOffer,
  addNewCampaign,
  duplicateProductHandler,
}) => {
  const { t } = useTranslation()

  return (
    <UncontrolledDropdown>
      <DropdownToggle tag="a" className="card-drop">
        <i className="mdi mdi-dots-vertical font-size-18"></i>
      </DropdownToggle>

      <DropdownMenu className="dropdown-menu-end">
        <DropdownItem onClick={() => viewDetailsHandler(product)}>
          <span className="">{t("common_viewDetails")}</span>
        </DropdownItem>
        <DropdownItem onClick={() => editProductHandler(product)}>
          <span className="">{t("common_edit")}</span>
        </DropdownItem>
        {/* <DropdownItem onClick={() => addNewOffer(product)}>
          <span className="">{t("common_addOffer")}</span>
        </DropdownItem>
        <DropdownItem onClick={() => addNewCampaign(product)}>
          <span className="">{t("common_addCompaign")}</span>
        </DropdownItem> */}
        <DropdownItem onClick={() => duplicateProductHandler(product)}>
          <span className="">{t("products_duplicateProduct")}</span>
        </DropdownItem>
        <DropdownItem onClick={() => deleteProductHandler(product)}>
          <span className="text-danger">{t("products_deleteProduct")}</span>
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  )
}
